// import { HttpInterceptorFn } from '@angular/common/http';

// export const authInterceptor: HttpInterceptorFn = (req, next) => {

//   const token = localStorage.getItem('authToken')

//   if(token){
//     req = req.clone({
//       setHeaders: {
//         Authorization: `Bearer ${token}`
//       }
//     })
//   }
//   return next(req);
// };

// import { HttpInterceptorFn } from '@angular/common/http';

// export const authInterceptor: HttpInterceptorFn = (req, next) => {
//   const token = localStorage.getItem('authToken');

//   if (token) {
//     req = req.clone({
//       setHeaders: {
//         Authorization: `Bearer ${token}`
//       }
//     });
//   }

//   return next(req);
// };

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = localStorage.getItem('authToken');
  const router = inject(Router);

  if (req.url.includes('/login')) {
    return next(req);
  }

  let authReq = req;

  if (token) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
}
  return next(authReq).pipe(
    catchError(err=>{

      const latestToken = localStorage.getItem('authToken');

      if(err.status === 401 && token && isTokenExpired(token)){
        // Handle unauthorized access, e.g., redirect to login
        localStorage.removeItem('authT oken');
          router.navigate(['/login']);
      }
      if(err.status === 403){
        // Handle forbidden access, e.g., show an alert or redirect
        alert('You do not have permission to access this resource.');
      }
      return throwError(()=>err);
    })
  );
}